import { MediaLibPanel } from "@editor/modules/media-lib";
import { useMediaLibDialogCtx } from "@editor/modules/media-lib/ctx";
import { useMediaLibDialogStoreShallow } from "@editor/modules/media-lib/stores";
import {
  type IMediaLibDialogItem,
  MediaLibPresetEnum,
} from "@editor/modules/media-lib/types";
import type { IMediaFile } from "@/shared/types";

export const MediaDialogMyFiles = () => {
  const { isMultiSelect, onSelect, preset, source } = useMediaLibDialogCtx();
  const { toggleSelectedItem, selectedItems } = useMediaLibDialogStoreShallow(
    (s) => ({
      selectedItems: s.selectedItems,
      toggleSelectedItem: s.toggleSelectedItem,
    }),
  );
  const handleClick = (media: IMediaFile) => {
    const mediaType = media.typeGroup;
    if (!canMultiselect(source, mediaType, preset)) return;

    const item: IMediaLibDialogItem = {
      id: media._id,
      url: media.url,
      type: mediaType === "image" ? "image" : "video",
      mediaFrom: "my-library",
      mediaFile: media,
    };

    if (!isMultiSelect && source === "default") {
      onSelect(item);
      return;
    }

    toggleSelectedItem(item);
  };

  return (
    <>
      <MediaLibPanel
        view="dialog"
        onSelect={handleClick}
        selectedItems={selectedItems}
        isMultiSelect={isMultiSelect}
        preset={preset}
        source={source}
      />
    </>
  );
};

const canMultiselect = (
  source: "default" | "settings",
  mediaType: string,
  preset: string,
) => {
  if (source === "settings") return true;
  if (preset === MediaLibPresetEnum.OnlyImages && mediaType === "video") {
    return false;
  }
  if (preset === MediaLibPresetEnum.OnlyVideos && mediaType === "image") {
    return false;
  }

  if (!["image", "video"].includes(mediaType)) {
    return false;
  }

  return true;
};
